import {finalize} from 'rxjs/operators';
import { Component, OnInit, ViewChild, ElementRef, AfterViewInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { CLAccount } from './account';
import { CLAccountService } from './account.service';
import { NotifierService, DialogService } from '../../ui';
import { FormControl, Validators } from '@angular/forms';

type ViewMode = 'view' | 'new' | 'edit';

@Component({
  templateUrl: './account-edit.component.html',
})
export class CLAccountEditComponent implements OnInit, AfterViewInit {

  account: CLAccount

  mode: ViewMode
  title: string

  @ViewChild('nameInput')
  nameInput: ElementRef

  name: FormControl

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private accountService: CLAccountService,
    private notifier: NotifierService,
    private dialogService: DialogService
  ) { }

  initForm() {
    // name
    this.name = new FormControl(this.account.name, [
      Validators.required
    ]);

    this.name.valueChanges.subscribe((value) => {
      this.account.name = value;
    });
  }
  
  ngAfterViewInit() {
    // Focus name input
    if (this.nameInput) {
      this.nameInput.nativeElement.focus();
    }
  }

  ngOnInit() {

    this.mode = this.route.routeConfig.data.mode;
    this.title = this.route.routeConfig.data.title;

    switch (this.mode) {
      case 'new': 
        {
          this.account = new CLAccount();

          this.initForm();
        }
        break;

      case 'edit':
        {
          // Get the account
          this.notifier.startProgress();

          this.route.data.subscribe((data) => {
            this.account = data.account;

            this.initForm();

            this.notifier.endProgress();
          });
        }
        break;

      case 'view':
        {
          // Get the account
          this.notifier.startProgress();

          this.route.data.subscribe((data) => {
            this.account = data.account;

            this.notifier.endProgress();
          });
        }
        break;
    }
  }

  save() {
    if (!this.account || !this.account.valid) {
      return;
    }

    let notifier = this.notifier;

    notifier.updateProgress(20);

    function onComplete() {
      notifier.endProgress();
    }

    switch (this.mode) {
      case 'new':
        {
          this.accountService
            .create(this.account).pipe(
            finalize(onComplete))
            .subscribe((account) => {
              this.account = account;

              this.notifier.success('Compte client créé avec succès');

              // Got to view screen
              this.router.navigate(['shares-ledger', 'client-accounts', account.id]);
            });
        }
        break;

      case 'edit':
        {
          this.accountService
            .update(this.account.id, this.account).pipe(
            finalize(onComplete))
            .subscribe((account) => {
              this.account = account;

              this.notifier.success('Compte client enregistré avec succès');

              // Got to view screen
              this.router.navigate(['shares-ledger', 'client-accounts', account.id]);
            });
        }
        break;
    }
  }

  cancel() {
    if (this.mode === 'edit') {
      this.router.navigate(['shares-ledger', 'client-accounts', this.account.id]);
    }
    else {
      if (this.account.deleted) {
        this.router.navigate(['shares-ledger', 'client-accounts', 'deleted']);
      }
      else {
        this.router.navigate(['shares-ledger', 'client-accounts']);
      }
    }
  }

  delete() {
    this.dialogService
      .confirmDelete('Voulez-vous supprimer ce compte client?')
      .subscribe((result) => {
        if (!result) {
          return;
        }

        this.notifier.startProgress();

        this.accountService
          .delete(this.account.id)
          .subscribe((id) => {
            this.notifier.success('Compte client supprimé avec succès');

            this.router.navigate(['shares-ledger', 'client-accounts']);

          }, (err) => {
            this.notifier.endProgress();
          });
      });
    
    return false;
  }

  restore(account: CLAccount) {
    this.dialogService
      .confirm({
        title: 'Restauration',
        message: 'Voulez-vous restaurer ce compte client?',
        confirm_button_text: 'Restaurer',
        confirm_button_class: 'btn-primary'
      })
      .subscribe((result) => {
        if (!result) {
          return;
        }

        this.notifier.startProgress();

        this.accountService
          .restore(this.account.id)
          .subscribe((id) => {
            this.notifier.success('Compte client restauré avec succès');

            this.router.navigate(['shares-ledger', 'client-accounts', 'deleted']);

          }, (err) => {
            this.notifier.endProgress();
          });
      });
    
    return false;
  }
}
